import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
	toggleSignUp,
	toggleLogin,
	toggleSocial,
	toggleAdditional,
	toggleCheckInbox,
	closeModals,
} from "../../store/features/modalSlice";
import Modal from "../../components/shared/Modal";
import LoginModal from "../../components/LoginModal";
import SignUpModal from "../../components/SignUpModal";
import AdditionalDetails from "../../components/AdditionalDetails";
import SocialModal from "../../components/SocialModal";
import CheckInboxModal from "../../components/CheckInboxModal";
import ResetPassword from "../../components/forget-password/ResetPassword";
import ResetWorkMail from "../../components/forget-password/ResetWorkMail";
import ResetMailSend from "../../components/forget-password/ResetMailSent";
import PasswordUpdated from "../../components/forget-password/PasswordUpdated";
import { useState } from "react";

export default function UserLoginLayout() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [encryptedMail, setEncryptedMail] = useState("");
	const {
		showSignUp,
		showLogin,
		showReset,
		showSocial,
		resetWorkMail,
		showAdditional,
		showCheckInbox,
		resetMailSend,
		updatePassword,
	} = useSelector((state) => state.modal);
	return (
		<>
			<Outlet />

			<Modal
				isOpen={showLogin}
				onClose={() => dispatch(closeModals())}
				label="Log in"
			>
				<LoginModal
					onSignUpClick={() => {
						navigate("/user-signup");
					}}
					onSubmit={() => dispatch(closeModals())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>
			<Modal
				isOpen={showSignUp}
				onClose={() => dispatch(closeModals())}
				label="Sign up"
			>
				<SignUpModal
					setShowSignUp={() => {
						navigate("/user-signup");
					}}
					onLoginClick={() => {
						navigate("/user-login");
					}}
					onSubmit={() => dispatch(toggleCheckInbox())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>
			<Modal
				isOpen={showReset}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetPassword
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>
			<Modal
				isOpen={updatePassword}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password"
			>
				<PasswordUpdated
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetWorkMail}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetWorkMail onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showSocial}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<SocialModal
					onLoginClick={() => {
						navigate("/user-login");
					}}
					onAdditionalClick={() => dispatch(toggleAdditional())}
				/>
			</Modal>

			<Modal
				isOpen={showAdditional}
				onClose={() => dispatch(closeModals())}
				label="Additional Details"
				isCloseBtnDisable={true}
			>
				<AdditionalDetails onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showCheckInbox}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<CheckInboxModal onClose={() => dispatch(closeModals())} />
			</Modal>
		</>
	);
}
